function support_links(lang: string= "en") {
  return {
    home_st: `https://www.st.com/content/st_com/${lang}.html`
    , help: "/help/#/introducing"
    , video_tutorial: "https://youtu.be/mEeZxco1ab4"
    , release_note: "/release_note/#/releasenote"
    , forum: "https://stcommunity.st.com/t5/other-software/bd-p/other-software-forum"

    , my_st_com: `https://my.st.com/content/my_st_com/${lang}.html`
    , my_space: `https://my.st.com/content/my_st_com/${lang}/my-space/my-preferences.html`
    , my_profile: `https://my.st.com/content/my_st_com/en/my-space/my-preferences.html`
    , my_preferences: `https://my.st.com/content/my_st_com/${lang}/my-space/my-preferences.html`
    , terms_of_use: `https://www.st.com/content/st_com/${lang}/common/terms-of-use.html`
    , privacy_portal: `https://www.st.com/content/st_com/${lang}/common/privacy-policy.html`
    , contact_us: `https://www.st.com/content/st_com/${lang}/contact-us.html`
    , manage_cookies: `https://www.st.com/content/st_com/${lang}/common/cookies-policy.html`
    , exercise_rights: `https://app-de.onetrust.com/app/#/webform/2b87200d-4023-4588-9df7-ab0cdea1a67e`

    // Used when eDS has no solutions.
    , stsales_offices: `https://www.st.com/content/st_com/${lang}/contact-us.html`
    , distributors: `https://www.st.com/content/st_com/${lang}/contact-us.html`
    , power_management: `https://www.st.com/${lang}/power-management.html`
    , online_sales_support: `https://www.st.com/content/st_com/${lang}/support/online-support.html`
    , product_selector: `https://www.st.com/content/st_com/${lang}/product-selector-welcome.html`
    , console_home: '/'
  };
}

const support_lang = {
  en: "en",
  zh: "zh",
  ja: "ja"
};

export function support_to_url(req_supp: string, lang: string = "en" ) {
  const str = "" + req_supp.toLowerCase();
  const supLang = support_lang[lang] || "en";
  const _suppport_links = support_links(supLang);

  return _suppport_links[str] || _suppport_links["home_st"];
}
